import React from 'react';

interface PopoverContentProps {
    patient: PatientType;
}

export function PopoverContent({ patient }: PopoverContentProps) {
    return (
        <>
            {Array.isArray(patient.pcps) && (
                <>
                    <span className="fw-bold">PCP: </span>
                    {patient.pcps[0].name}
                    <br />
                </>
            )}
            <span className="fw-bold">Member ID: </span>
            {patient.insurance_plans?.[0]?.insco_id}
            <br />
            {Array.isArray(patient.phones) && patient.phones.length > 0 && (
                <>
                    <span className="fw-bold">Phone: </span>
                    {patient.phones[0].number}
                </>
            )}
        </>
    );
}
